$(document).ready(function() {
    $('.js-slick').each(function() {
        var $slick = $(this);
        var $slickImages = $slick.children();

        $slick.on('init', function(event, slick) {
            var hiddenThumbs = 0;
            var $lastVisibleThumb;

            $slick.lightGallery({
                autoplay: false,
                autoplayFirstVideo: true,
                download: false,
                exThumbImage: 'data-thumb',
                loadYoutubeThumbnail: true,
                selector: slick.$slides,
                youtubeThumbSize: 'mqdefault',
                youtubePlayerParams: {
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0
                },
                thumbWidth: 80
            });

            if(slick.$dots) {
                var parentWidth = slick.$dots.parent().width();
                var parentOffset = slick.$dots.offset().left;

                slick.$dots.find('li').each(function() {
                    var $thumb = $(this);
                    var width = $thumb.width();
                    var offsetRight = ($thumb.offset().left + width) - parentOffset;

                    if(offsetRight > parentWidth) {
                        $thumb.addClass('d-none');
                        hiddenThumbs++;
                    } else {
                        $lastVisibleThumb = $thumb;
                    }
                });

                if(hiddenThumbs > 0) {
                    $lastVisibleThumb.find('.slick-thumb').attr('data-plus', '+'+(hiddenThumbs + 1));
                }
            }

            $slick.find('.slick-next').addClass('arrow next');
            $slick.find('.slick-prev').addClass('arrow prev');
            $slick.removeClass('d-none');
        });

        $slick.not('.slick-initialized').slick({
            adaptiveHeight: false,
            appendDots: $slick.parent(),
            customPaging: function(slider, i) {
                var slide = slider.$slides[i];
                var $slide = $(slide);
                var thumb = $slide.data('thumb');
                var $thumb = $('<img/>').attr({'src': thumb});
                var $dot = $('<div/>').attr({'class': 'slick-thumb'}).html($thumb);
                if($slide.hasClass('slick-video')) {
                    $dot.addClass('slick-thumb-video');
                }
                $dot.on('click', function() {
                    if($dot.attr('data-plus') || $slide.hasClass('slick-video')) {
                        $slide.trigger('click');
                        return false;
                    }
                });
                return $dot;
            },
            dots: ($slickImages.length > 1),
            infinite: true,
            initialSlide: 0
        });
    });

    $('.js-trigger-slick-video').each(function() {
        var $trigger = $(this);
        var $slickVideo = $('.slick-thumb-video');

        $trigger.on('click', function() {
            $slickVideo.click();
            return false;
        });
    });
});
